import { render, staticRenderFns } from "./DingDingMsg.vue?vue&type=template&id=3fbb7166"
import script from "./DingDingMsg.vue?vue&type=script&lang=js"
export * from "./DingDingMsg.vue?vue&type=script&lang=js"
import style0 from "./DingDingMsg.vue?vue&type=style&index=0&id=3fbb7166&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports